import React from 'react';
import { NewModal } from 'lib/components';
import { Button, Typography } from 'react-covideo-common';
import { Flex } from 'lib/components/styles/layout';
import { useTranslation } from 'react-i18next';

type Props = {
  onModalClose: () => void;
  onConfirm: () => void;
  disabled?: boolean;
};

export const AISpotLightConfirmationModal = ({
  onModalClose,
  onConfirm,
  disabled,
}: Props) => {
  const { t } = useTranslation();
  return (
    <NewModal closeModal={onModalClose} headerText={t('Create AI Flex Video?')}>
      <Flex flexDirection='column' alignItems='center' margin='0 0 16px 0'>
        <Typography variant='normal' fontWeight='400'>
          {t(
            'Confirm Flex Video creation. This action will use one credit from your balance.'
          )}
        </Typography>
      </Flex>
      <Flex
        width='100%'
        justifyContent='flex-end'
        flexDirection='row'
        gap='16px'
      >
        <Button
          variant='secondary'
          text={t('Cancel')}
          onClick={onModalClose}
          type='button'
          disabled={disabled}
        />
        <Button
          text={t('Create AI Flex Video')}
          onClick={onConfirm}
          disabled={disabled}
          type='submit'
        />
      </Flex>
    </NewModal>
  );
};
